<h2>
  {{ title }}
  <span *ngIf="model.Id" title="Market Id">- {{ model.Id }} </span>
  <span *ngIf="model.Name">- {{ model.Name }}</span>
</h2>
<hr />

<div class="divrel">
  <tabset #tabs>
    <tab heading="General">
      <br />
      <form
        (ngSubmit)="onSubmit()"
        #editFacilityForm="ngForm"
        class="editForm"
        novalidate
        [ngBusy]="busy"
      >
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label">Name</label>
              <input type="text" #name class="form-control" name="Name" [(ngModel)]="model.Name" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="check-form-group">
              <div class="check">
                <input
                  type="checkbox"
                  id="checkboxIsActive"
                  name="IsActive"
                  [(ngModel)]="model.IsActive"
                />
                <label for="checkboxIsActive"></label>
              </div>
              <label for="checkboxIsActive">Is Active</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">Program Name</label>
              <input
                type="text"
                #name
                class="form-control"
                name="OrganizationName"
                [(ngModel)]="model.OrganizationName"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">Program Phone Number</label>
              <input
                type="text"
                #name
                class="form-control"
                [appInputMask]="util.constants.masks.usPhone"
                name="OrganizationPhoneNumber"
                [(ngModel)]="model.OrganizationPhoneNumber"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">Operations Director</label>
              <app-select
                id="operationsDirector"
                name="operationsDirector"
                #operationsDirectorList
                [items]="operationsLeaderUsers"
                [allowClear]="true"
                [selected]="selectedOperationsDirector"
                [removed]="selectedOperationsDirector"
                placeholder="Select Operations Director"
                [filterInactive]="true"
              >
              </app-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">Screening Teams Channel Link</label>
              <input
                type="text"
                #name
                class="form-control"
                name="ScreeningChannelLink"
                [(ngModel)]="model.MarketChannel.ScreeningChannelLink"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">Admission Teams Channel Link</label>
              <input
                type="text"
                #name
                class="form-control"
                name="AdmissionChannelLink"
                [(ngModel)]="model.MarketChannel.AdmissionChannelLink"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">Rehab Admission Teams Channel Link</label>
              <input
                type="text"
                #name
                class="form-control"
                name="RehabAdmissionChannelLink"
                [(ngModel)]="model.MarketChannel.RehabAdmissionChannelLink"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">PeopleSoft Business Unit</label>
              <input
                type="text"
                #name
                class="form-control"
                name="PeopleSoftBusinessUnit"
                [(ngModel)]="model.PeopleSoftBusinessUnit"
              />
            </div>
          </div>
        </div>

        <hr />

        <div class="row">
          <button class="btn btn-default pull-right" type="button" (click)="backToList()">
            Back to list
          </button>
          <button type="submit" class="btn btn-success pull-right" style="margin-right: 15px">
            Save
          </button>
        </div>
      </form>
    </tab>
    <tab heading="Providers" [disabled]="!this.model.Id">
      <app-market-edit-providers
        *ngIf="tabs.tabs[1].active === true"
        [marketId]="marketId"
      ></app-market-edit-providers>
      <hr />
      <div class="row">
        <button class="btn btn-default pull-right" (click)="backToList()">Back to list</button>
      </div>
    </tab>

    <tab heading="Coverage">
      <app-market-edit-coverage
        *ngIf="tabs.tabs[2].active === true"
        [model]="model"
      ></app-market-edit-coverage>
      <hr />
      <button class="btn btn-default pull-right" (click)="backToList()">Back to list</button>
      <button
        type="submit"
        (click)="onSubmit()"
        class="btn btn-success pull-right"
        style="margin-right: 15px"
      >
        Save
      </button>
    </tab>
  </tabset>
</div>
